import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      gap: theme.spacing(2),
    },
    titleWrapper: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
    },
    iconWrapper: {
      position: 'absolute',
      right: 'calc(100% + 16px)',
    },
    title: {
      color: COLORS.gray.black,
    },
    description: {
      color: COLORS.neutral.darkGray,
      whiteSpace: 'pre-line',
    },
  }),
  { name: 'BrandVoiceItemEmptyBanner' }
);
